var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { joiResolver } from '@hookform/resolvers/joi';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { fetchConversionRequests } from '@popup/steem/actions/conversion.actions';
import { ConversionType } from '@popup/steem/pages/app-container/home/conversion/conversion-type.enum';
import { ConversionUtils } from '@popup/steem/utils/conversion.utils';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { Asset as CommonAsset } from '@steempro/steem-keychain-commons';
import Joi from 'joi';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { BalanceSectionComponent } from 'src/common-ui/balance-section/balance-section.component';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { FormInputComponent } from 'src/common-ui/input/form-input.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { Screen } from 'src/reference-data/screen.enum';
import { FormUtils } from 'src/utils/form.utils';
import FormatUtils from 'src/utils/format.utils';
const rules = FormUtils.createRules({
    receiver: Joi.string().required(),
    amount: Joi.number().required().positive().max(Joi.ref('$maxAmount')),
});
const Conversion = ({ currencyLabels, activeAccount, conversionType, conversions, formParams, navigateToWithParams, navigateTo, setSuccessMessage, setErrorMessage, addToLoadingList, removeFromLoadingList, setTitleContainerProperties, fetchConversionRequests, }) => {
    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            receiver: formParams.receiver ? formParams.receiver : activeAccount.name,
            amount: formParams.amount ? formParams.amount : '',
            currency: currencyLabels.sbd,
        },
        resolver: (values, context, options) => {
            const resolver = joiResolver(rules, {
                context: { maxAmount: available },
                errors: { render: true },
            });
            return resolver(values, { maxAmount: available }, options);
        },
    });
    const [available, setAvailable] = useState('...');
    const [totalPending, setTotalPending] = useState(0);
    const [pendingConversions, setPendingConversions] = useState([]);
    useEffect(() => {
        setTitleContainerProperties({ title: title, isBackButtonEnabled: true });
    }, []);
    useEffect(() => {
        fetchConversionRequests(activeAccount.name);
        const sbdBalance = FormatUtils.toNumber(activeAccount.account.sbd_balance);
        setAvailable(sbdBalance);
    }, [activeAccount]);
    useEffect(() => {
        const conv = conversions.filter((conversion) => {
            return (conversionType === ConversionType.CONVERT_SBD_TO_STEEM &&
                !conversion.collaterized);
        });
        setPendingConversions(conv);
        const total = conv.reduce((previous, current) => {
            return previous + CommonAsset.fromString(current.amount).amount;
        }, 0);
        setTotalPending(total);
    }, [conversions]);
    const title = 'popup_html_convert_hbd';
    const text = 'popup_html_convert_hbd_intro';
    const handleButtonClick = (form) => {
        if (parseFloat(form.amount.toString()) > parseFloat(available.toString())) {
            setErrorMessage('popup_html_power_up_down_error');
            return;
        }
        const formattedValue = `${parseFloat(form.amount.toString()).toFixed(3)} ${form.currency}`;
        const stringifiedAmount = `${FormatUtils.formatCurrencyValue(parseFloat(form.amount.toString()))} ${form.currency}`;
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage(conversionType === ConversionType.CONVERT_SBD_TO_STEEM
                ? 'popup_html_confirm_hbd_to_hive_conversion'
                : 'popup_html_confirm_hive_to_hbd_conversion'),
            fields: [
                { label: 'popup_html_value', value: stringifiedAmount },
                { label: 'popup_html_username', value: `@${activeAccount.name}` },
            ],
            title: title,
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_conversion_operation');
                try {
                    let success = yield ConversionUtils.convert(activeAccount.name, conversions, formattedValue, conversionType, activeAccount.keys.active, options);
                    if (success) {
                        navigateTo(Screen.HOME_PAGE, true);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else {
                            setSuccessMessage(conversionType === ConversionType.CONVERT_SBD_TO_STEEM
                                ? 'popup_html_hbd_to_hive_conversion_success'
                                : 'popup_html_hive_to_hbd_conversion_success');
                        }
                    }
                    else {
                        setErrorMessage(conversionType === ConversionType.CONVERT_SBD_TO_STEEM
                            ? 'popup_html_hbd_to_hive_conversion_fail'
                            : 'popup_html_hive_to_hbd_conversion_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_conversion_operation');
                }
            }),
        });
    };
    const setToMax = () => {
        setValue('amount', Number(available));
    };
    const getFormParams = () => {
        return watch();
    };
    const goToPendingConversion = () => {
        navigateToWithParams(Screen.PENDING_CONVERSION_PAGE, {
            pendingConversions: pendingConversions,
            currency: watch('currency'),
        });
    };
    return (React.createElement("div", { className: "conversion-page", "data-testid": `${Screen.CONVERSION_PAGE}-page` },
        React.createElement(BalanceSectionComponent, { unit: watch('currency'), value: available, label: "popup_html_balance", decimals: 3 }),
        totalPending > 0 && (React.createElement("div", { className: "pending-conversion-panel", onClick: goToPendingConversion },
            React.createElement("div", { className: "pending-conversion-text" },
                totalPending,
                " ",
                watch('currency'),
                ' ',
                getMessage('popup_html_pending'),
                ' '))),
        React.createElement(FormContainer, { onSubmit: handleSubmit(handleButtonClick) },
            React.createElement("div", { className: "text" }, getMessage(text)),
            React.createElement(Separator, { fullSize: true, type: "horizontal" }),
            React.createElement("div", { className: "form-fields" },
                React.createElement("div", { className: "amount-panel" },
                    React.createElement(FormInputComponent, { classname: "currency-fake-input", dataTestId: "currency-input", control: control, name: "currency", type: InputType.TEXT, label: "popup_html_currency", disabled: true }),
                    React.createElement(FormInputComponent, { name: "amount", dataTestId: "amount-input", control: control, type: InputType.NUMBER, placeholder: "0.000", skipPlaceholderTranslation: true, label: "popup_html_amount", min: 0, rightActionClicked: setToMax, rightActionIcon: SVGIcons.INPUT_MAX }))),
            React.createElement(OperationButtonComponent, { dataTestId: "submit-button", label: title, onClick: handleSubmit(handleButtonClick), requiredKey: KeychainKeyTypesLC.active }))));
};
const mapStateToProps = (state) => {
    var _a, _b, _c;
    return {
        activeAccount: state.steem.activeAccount,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        conversionType: state.navigation.stack[0].params
            .conversionType,
        conversions: state.steem.conversions,
        formParams: ((_b = state.navigation.stack[0].previousParams) === null || _b === void 0 ? void 0 : _b.formParams)
            ? (_c = state.navigation.stack[0].previousParams) === null || _c === void 0 ? void 0 : _c.formParams
            : {},
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setSuccessMessage,
    setErrorMessage,
    addToLoadingList,
    removeFromLoadingList,
    setTitleContainerProperties,
    fetchConversionRequests,
});
export const ConversionComponent = connector(Conversion);
